module.exports = __webpack_public_path__ + "img/buy0440.52cf2895.svg";